
<div class="vendor">
    <!-- App common header -->
    <!-- <app-header></app-header> -->
  
    <div class="body-proxy">
      <!-- App body loads here -->
      <router-outlet></router-outlet>
    </div>
  </div>
  
  